function SectionEyebrow({ children }) {
  return (
    <span className="inline-flex rounded-full bg-peach/12 px-4 py-2 text-xs font-extrabold uppercase tracking-[0.2em] text-coral">
      {children}
    </span>
  );
}

window.AppComponents = window.AppComponents || {};
window.AppComponents.SectionEyebrow = SectionEyebrow;
